<template>
  <v-container fluid class="py-0">
    <v-row class="py-4 text-center justify-center max-width-1200 mx-auto" align="center">
      <v-col cols="12" sm="12" md="4" lg="4" style="display:contents;">
        <img
          alt="Széchenyi 2020"
          class="my-2 mr-4 mouse-hover-link"
          src="@/assets/tender-vekop-02.webp"
          loading="lazy"
          height="80" width="200"
          style="object-fit:contain;"
          @click="openDialog('vekop')">
        <img
          alt="Európai Regionális Fejlesztési Alap"
          class="my-2 mr-12 mouse-hover-link"
          src="@/assets/tender-vekop-01.webp"
          loading="lazy"
          height="80" width="233"
          style="object-fit:contain;"
          @click="openDialog('vekop')">
        <img
          alt="NKFI"
          class="my-2 mouse-hover-link"
          src="@/assets/tender-nkfi-01.webp"
          loading="lazy"
          height="80" width="162"
          style="object-fit:contain;"
          @click="openDialog('nkfi')">
        <img
          alt="NKFI"
          class="my-2 mouse-hover-link"
          src="@/assets/tender-nkfi-02.webp"
          loading="lazy"
          height="80" width="123"
          style="object-fit:contain;"
          @click="openDialog('nkfiEnd')">
      </v-col>
    </v-row>


    <!-- dialog -->
    <v-dialog
      v-model="tender.dialog"
      width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{$t(tender.selected.title)}}
          </span>
        </v-card-title>
        <v-card-subtitle>
          <span class="">
            {{$t(tender.selected.subtitle)}}
          </span><br>
        </v-card-subtitle>
        <v-card-subtitle>
          <span class="">
            {{$t(tender.selected.data)}}
          </span>
        </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-text class="pt-4 text-justify max-height-500 overflow-y">
          <div v-html="parseHtml($t(tender.selected.text))"></div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="closeDialog()">
            {{ $t("common.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'Tender',
    extends: DataComponentBase,

    props: {
      parentOpen: {
        type: String,
        default: false,
      },
    },

    data() {
      return {
        tender: {
          dialog: false,
          selected: {
            title: "",
            subtitle: "",
            text: "",
          },
        },
      }
    },

    methods: {
      openDialog(tender) {
        this.tender.dialog = true;
        this.tender.selected.title = ("tender." + tender + ".title");
        this.tender.selected.subtitle = ("tender." + tender + ".subtitle");
        this.tender.selected.data = ("tender." + tender + ".data");
        this.tender.selected.text = ("tender." + tender + ".text");
      },
      closeDialog() {
        this.tender.dialog = false;
        this.$emit('dialogClosed');
      },
      parseHtml(rawText) {
        let parser = new DOMParser();
        let doc = parser.parseFromString(rawText, "text/html");
        return doc.querySelector("body").innerHTML;
      },
      openLink(link) {
        let url = link;
        window.open(url,'_blank');
      },
    },

    watch: {
      parentOpen() {
        if(this.parentOpen == 'vekop') {
          this.openDialog('vekop');
        } else if(this.parentOpen == 'nkfi') {
          this.openDialog('nkfiEnd');
        }
      },
    },
  }
</script>
